import { render, staticRenderFns } from "./NotificationDetailPanel.vue?vue&type=template&id=393be9a8&scoped=true"
import script from "./NotificationDetailPanel.vue?vue&type=script&lang=js"
export * from "./NotificationDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailPanel.vue?vue&type=style&index=0&id=393be9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393be9a8",
  null
  
)

export default component.exports